<template>
  <div class="grid">
    <div class="header">
      <Header />
    </div>
    <div class="iconsBar">
      <IconBar class="bg-panel p-4" />
    </div>
    <div class="toolsBar bg-panel-sec">
      <Toolbar />
    </div>
    <div class="main">
      <slot></slot>
    </div>
    <div class="manager overflow-scroll bg-panel">
      <PropertyManager />
    </div>
    <footer class="footer  color-text-muted text-right p-2 px-4 text-xs">© wadasol 2020</footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { UiTabs } from "@/util";
import { UUID } from "../util";
import { AppService } from "./../store";
export default {
  name: "Layout",
  props: {
    msg: String
  },
  data() {
    return {
      name: ""
    };
  },
  mounted() {},
  computed: {
    ...mapGetters([
      "components",
      "rootNode",
      "selectedComponent",
      "isSelectedComponent",
      "featherIcons"
    ])
  },
  methods: {
    ...mapActions([
      "editComponent",
      "addComponent",
      "addIcon",
      "selectNode",
      "deleteComponent",
      "onRename",
      "changePercent"
    ])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.outline {
  outline: 1px dashed rgb(212, 208, 240);
}

.outline-select {
  outline: 1px dashed rgb(94, 98, 222);
}
</style>
